import { GET_AUP_LIST, UPDATE_AUP, POST_AUP, DELETE_AUP } from '../../types'

const initialState = {
  aupList: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_AUP_LIST: return {
      ...state,
      aupList: action.payload
    }
    case UPDATE_AUP: return {
      ...state
    }
    case POST_AUP: return {
      ...state
    }
    case DELETE_AUP: return {
      ...state
    }
    default: return { ...state }
  }
}
